import React from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonContent, IonHeader } from '@ionic/react'
import './index.scss'

interface IProps {
  reject?: () => void;
  resolve?: (product: any) => void;
  pics: any[];
}

const BusinessLicenseModal: React.FC<IProps> = ({ pics, reject }) => {
  return (
    <IonModal
      cssClass='business-license-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss={false}
    >
      <IonHeader>
        <i className='iconfont icon-close' onClick={reject}></i>
      </IonHeader>
      <IonContent>
        {
          pics?.map(pic => <img key={pic.url} src={pic.url} />)
        }
      </IonContent>
    </IonModal>
  )
}

export default observer(BusinessLicenseModal)
